import { LearnerResultStatus } from 'modules/classes/core/enum';
import type { Classes } from 'modules/classes/core/type';
import type { FunctionalTest } from 'modules/dashboard/core/type';
import type { Institution } from 'modules/institutions/core/type';

export interface UserMeasurement {
  height?: number;
  weight?: number;
  bmi?: number;
  bodyFat?: number;
  skeletalMuscle?: number;
  visceralFatLevel?: number;
  restingMetabolism?: number;
}

export interface LearnerFormRequest extends UserMeasurement {
  firstName: string;
  lastName: string;
  nickname: string;
  name: string;
  gender: string;
  phone: string;
  yearOfBirth: number | null;
  monthOfBirth?: number | null;
  dayOfBirth?: number | null;
  email?: string;
  password: string;
  institutionId?: string;
}
export interface Learner {
  id: string;
  nickname: string;
  name: string;
  firstName: string;
  lastName: string;
  phone: string;
  isAccount: boolean;
  email?: string;
  isActive: boolean;
  createdAt: string;
  password?: string;
  physicalProfile?: {
    gender: string;
    avatar?: string;
    yearOfBirth: number | null;
    monthOfBirth: number | null;
    dayOfBirth: number | null;
  };
  measurement?: UserMeasurement;
  userClassId?: string;
  institution: Institution;
  userClassGroupId?: string;
  assessmentResult?: AssessmentResultProps;
  cfsResult?: CFSResultProps;
  fropResult?: FropResultProps;
  classes?: {
    class: Classes;
  }[];
  status?: LearnerResultStatus;
  levelCFS?: number;
}

// export interface LearnerDetail {
//   id: string;
//   nickname: string;
//   name: string;
//   phone: string;
//   email?: string;
//   isActive: boolean;
//   createdAt: string;
//   password?: string;
//   age?: number;
//   height?: number;
//   weight?: number;
//   bmi?: number;
//   gender: string;
//   dateOfBirth?: Date;
//   userClassId?: string;
//   institution: Institution;
//   userClassGroupId?: string;
//   bodyFat: number | null;
//   restingMetabolism: number | null;
//   skeletalMuscle: number | null;
//   visceralFatLevel: number | null;
//   classes?: {
//     class: Classes;
//   }[];
//   assessmentResult?: AssessmentResultProps;
//   cfsResult?: CFSResultProps;
//   fropResult?: FropResultProps;
// }

export interface AssessmentResultProps {
  createdAt: string;
  totalScore: number;
  functionalTests: FunctionalTest[];
  name: string;
  isDraft?: boolean;
  levelBFT?: number;
}

export interface CFSResultProps {
  createdAt: string;
  totalScore: number;
  answer: string;
  description: string;
}

interface FropResultProps {
  createdAt: string;
  totalScore: number;
  title: string;
  description: string;
  maxScore: number;
}

export interface Survey {
  id: string;
  title: string;
  surveyOptions: SurveyOption[];
  createdAt: string;
}

export interface SurveyOption {
  id: string;
  index: number;
  value: string;
}

export interface SurveyResult {
  id: string;
  survey: Survey;
  surveyOption: SurveyOption;
  createdAt: string;
}

export interface SurveyResultReport {
  survey: Survey;
  results: SurveyResult[];
}

interface FropQuestion {
  id: string;
  question: string;
  component: string;
  items: FropQuestion[];
}

interface FropAnswer {
  answer: string;
  healthFropQuestion: FropQuestion;
}

export interface FropResult {
  id: string;
  answers: FropAnswer[];
  score: number;
  createdAt: string;
}

export interface FropResultReport {
  questions: FropQuestion[];
  results: FropResult[];
}

interface CfsQuestion {
  id: string;
  question: string;
  answerNo: string;
  answerYes: string;
  description: string;
}

export interface CfsResult {
  id: string;
  healthCFSQuestion: CfsQuestion;
  score: number;
  createdAt: string;
  isAnswer: boolean;
}

export interface CfsResultReport {
  results: CfsResult[];
}

export enum TestMethod {
  'Enter rep count' = 'Enter rep count',
  'Enter score' = 'Enter score',
  'Time' = 'Time',
  'Kg' = 'Kg',
}

export interface OnboardingFunctionalTest {
  id: string;
  name: string;
  thumbnail: string;
  method: TestMethod;
  maxScore: number;
  isAddition: boolean;
  isSO2AndHR: boolean;
}

export interface OnboardingAnswer {
  id: string;
  score: number;
  functionalTest: OnboardingFunctionalTest;
  timeCount: number;
  preSpO2: number;
  preHR: number;
  postSpO2: number;
  postHR: number;
  recoverySpO2: number;
  recoveryHR: number;
  comment?: string;
  scoreAddition: number;
}

export interface OnboardingResult {
  id: string;
  assessmentName: string;
  answers: OnboardingAnswer[];
  updatedAt: string;
}

export interface OnBoardingResultReport {
  results: OnboardingResult[];
}
